document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.getElementById("openMobileMenu");
  const openBtnMob = document.getElementById("mobileToggle");
  const drawer = document.getElementById("mobileMenuDrawer");
  const overlay = document.getElementById("mobileMenuOverlay");
  const closeBtn = document.getElementById("closeMobileMenu");

  /* ----------------------------------------------------
     OPEN DRAWER
  ---------------------------------------------------- */
  if (openBtn) {
    openBtn.addEventListener("click", function (e) {
      e.preventDefault();
      drawer.classList.add("open");
      openBtn.classList.add("active");
      document.body.classList.add("menu-open");
    });
  }
  if (openBtnMob) {
    openBtnMob.addEventListener("click", function (e) {
      e.preventDefault();
      drawer.classList.add("open");
      openBtnMob.classList.add("active");
      document.body.classList.add("menu-open");
    });
  }
  /* ----------------------------------------------------
     CLOSE DRAWER FUNCTION
  ---------------------------------------------------- */
  function closeDrawer() {
    drawer.classList.remove("open");
    openBtn.classList.remove("active");
    openBtnMob.classList.remove("active");
    document.body.classList.remove("menu-open");
  }

  /* Close when clicking overlay */
  if (overlay) {
    overlay.addEventListener("click", closeDrawer);
  }

  /* Close when clicking X button */
  if (closeBtn) {
    closeBtn.addEventListener("click", closeDrawer);
  }

  /* CLICK OUTSIDE → CLOSE DRAWER */
  document.addEventListener("click", function (event) {
    if (
      drawer.classList.contains("open") &&
      !drawer.contains(event.target) &&
      !openBtn.contains(event.target) &&
      !openBtnMob.contains(event.target)
    ) {
      closeDrawer();
    }
  });

  /* ----------------------------------------------------
     CHILD CLICK → SWITCH ACTIVE + SHOW MATCHING LIST
  ---------------------------------------------------- */
  const childItems = document.querySelectorAll(".m-child");

  childItems.forEach((child) => {
    child.addEventListener("click", function (e) {

      // prevent drawer closing when clicking inside
      e.stopPropagation();

      // Remove active from all
      childItems.forEach(c => c.classList.remove("active"));

      // Add active to selected
      this.classList.add("active");

      // Hide all grandchild sections
      const allGC = document.querySelectorAll(".mobile-menu-lv3");
      allGC.forEach(gc => gc.style.display = "none");

      // Show matching grandchild grid
      const target = this.getAttribute("data-target");
      if (target) {
        const match = document.querySelector(target);
        if (match) match.style.display = "grid";
      }
    });
  });

}); // END DOM READY


/* ----------------------------------------------------
   AUTO CLOSE MENU WHEN SCREEN ≥ 769px
---------------------------------------------------- */
function autoCloseOnDesktop() {
  const drawer = document.getElementById("mobileMenuDrawer");
  const openBtn = document.getElementById("openMobileMenu");
  const openBtnMob = document.getElementById("mobileToggle");
  if (drawer && window.innerWidth >= 769) {
    drawer.classList.remove("open");
    if (openBtn) openBtn.classList.remove("active");
    if (openBtnMob) openBtnMob.classList.remove("active");
  }
}

window.addEventListener("resize", autoCloseOnDesktop);
window.addEventListener("load", autoCloseOnDesktop);


/* ----------------------------------------------------
   STICKY HEADER (ORIGINAL CODE)
---------------------------------------------------- */
(function() {
  function updateHeights() {
    var header = document.querySelector('header#header') || document.querySelector('#shopify-section-header') || null;
    var navbar = document.querySelector('#shopify-section-Ishi_megamenu') || document.querySelector('.main-navbar') || null;

    var headerH = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    var navbarH = navbar ? Math.ceil(navbar.getBoundingClientRect().height) : 0;

    document.documentElement.style.setProperty('--header-height', headerH + 'px');
    document.documentElement.style.setProperty('--navbar-height', navbarH + 'px');

    // fallback inline top for older browsers or specificity issues
    if (navbar) navbar.style.top = headerH + 'px';

    // add class to body to enable CSS that depends on header being fixed
    // only add when header has computed position fixed
    var headerStyle = header ? window.getComputedStyle(header).position : '';
    if (header && headerStyle === 'fixed') {
      document.body.classList.add('with-fixed-header');
    } else {
      document.body.classList.remove('with-fixed-header');
    }
  }

  window.addEventListener('load', updateHeights);
  window.addEventListener('resize', updateHeights);

  // watch header for content changes (images/fonts)
  var headerNode = document.querySelector('header#header');
  if (headerNode && window.MutationObserver) {
    var mo = new MutationObserver(function() { setTimeout(updateHeights, 30); });
    mo.observe(headerNode, { attributes: true, childList: true, subtree: true });
  }

  // Also watch for navbar changes (if navbar loads later)
  var navNode = document.querySelector('#shopify-section-Ishi_megamenu') || document.querySelector('.main-navbar');
  if (navNode && window.MutationObserver) {
    var mo2 = new MutationObserver(function() { setTimeout(updateHeights, 30); });
    mo2.observe(navNode, { attributes: true, childList: true, subtree: true });
  }
})();
